module.exports = "pegasus/assets/email1-img13.png";